import React from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import {
  CheckCircle,
  CheckCircleOutline,
  Search,
  Visibility,
  SaveAlt,
  Payment,
} from "@material-ui/icons";
import ReactPaginate from "react-paginate";
import { DebounceInput } from "react-debounce-input";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Tooltip from "@material-ui/core/Tooltip";
import noRecord from "./../../../assets/img/no-record.png";
import moment from "moment";
import {
  getAllOwnersBillingHistoryAction,
  getInvoiceByPeriodAction,
  getAllAccOwnersAction,
  billingPaymentCaptureAction,
  getPaymentRecipt,
} from "../../../actions/BillingActions";
import InvoiceDetailsTable from "./../Invoices/InvoiceDetailsTable";
import { currencyFormat } from "./../../Common/Common";
import ReactSelect from "react-select";
import * as code from "./../../../config/Constants";
import { toastMessage } from "./../../Common/Common";
import * as message from "./../../../config/CommonMessages";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import UrlConstants from "../../../config/UrlConstants";
import BillingReceipt from "./BillingReceipt";

import Picker from "react-month-picker";
import "react-month-picker/css/month-picker.css";
import MonthBox from "./../../Common/MonthBox";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const columns = [
  {
    name: "Studio Owner Name",
    selector: "accOwnerName",
    sortable: true,
    ignoreRowClick: true,
  },
  {
    name: "Invoice Month/Year",
    selector: "monthYear",
    sortable: true,
    ignoreRowClick: true,
  },
  {
    name: "Amount",
    selector: "amount",
    sortable: true,
  },
  {
    name: "Payment status",
    selector: "PaymentStatus",
    sortable: true,
  },
  {
    name: "Status",
    selector: "status",
    // sortable: true,
  },
  {
    name: "Payment Date",
    selector: "created",
    sortable: true,
  },
  {
    name: "",
    selector: "action",
    right: true,
    ignoreRowClick: true,
  },
];

function BillingHistory({
  getAllOwnersBillingHistoryAction,
  getInvoiceByPeriodAction,
  getAllAccOwnersAction,
  billingPaymentCaptureAction,
  getPaymentRecipt,
}) {
  const [filterText, setFilterText] = React.useState(null);
  const [showLoader, setShowLoader] = React.useState(false);
  const [numberOfPages, setnumberOfPages] = React.useState();
  const [PageNumber, setPageNumber] = React.useState(0);
  const [Rerander, setRerander] = React.useState(0);
  const [PageSize, SetPageSize] = React.useState(10);

  const [billingHistory, setBillingHistory] = React.useState([]);
  const [invoiceDetails, setInvoiceDetails] = React.useState({});
  const [invoicePrompt, setInvoicePrompt] = React.useState(false);
  const [accOwnersList, setAccOwners] = React.useState([]);
  const [selectedAccOwner, setSelectedAccOwner] = React.useState("");
  const [userId, setUserId] = React.useState("");
  const [invoicePeriod, setInvoicePeriod] = React.useState("");
  const [invoiceReceipt, setInvoiceReceipt] = React.useState(false);
  const [receipthtml, setReceipthtml] = React.useState();
  const [isCurrentInvoice, setIsCurrentInvoice] = React.useState(false);
  const [invoiceId, setInvoiceId] = React.useState();
  const [selectedInvoicePeriod, setSelectedInvoicePeriod] = React.useState("");

  const pickAMonth = React.createRef();
  const pickerLang = {
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
  };
  const mvalue = {
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
  };
  let makeText = (m) => {
    if (m && m.year){
      if(m.month){
        return pickerLang.months[m.month - 1] + ". " + m.year;
      }
      else{
        return pickerLang.months[0] + ". " + m.year;
      }
    }
    return "Select";
  };

  const [singleValue, setSingleValue] = React.useState(mvalue);

  const handleAMonthChange = (year, month) => {
    // console.log("handleAMonthChange year", year);
    // console.log("handleAMonthChange month", month);
    let obj = {
      year: year,
      month: month,
    };
    setSingleValue(obj);
    let formattedMonth = ("0" + month).slice(-2);
    // console.log("handleAMonthChange formattedNumber", formattedMonth);
    let concatResult = year + formattedMonth;
    // console.log("handleAMonthChange concatResult", concatResult);
    setSelectedInvoicePeriod(Number(concatResult));
    handleAMonthDissmis();
    setRerander(!Rerander);
  };
  const handleAMonthDissmis = (value) => {
    // console.log("handleAMonthDissmis value==>", value);
    // setSingleValue(value);
  };

  const handleClickMonthBox = (e) => {
    pickAMonth.current.show();
  };

  function getYearsArray() {
    let currentYear = new Date().getFullYear();
    let years = [];
    let startYear = 2000;

    while (startYear <= currentYear) {
      years.push(startYear++);
    }
    // console.log('getYearsArray years==>',years);
    return years;
  }

  React.useEffect(() => {
    setShowLoader(true);
    getAllAccOwners();
  }, []);

  React.useEffect(() => {
    setShowLoader(true);
    getAllOwnersBillingHistory();
  }, [PageNumber, Rerander]);

  const handlePageClick = (event) => {
    setPageNumber(event.selected);
  };

  const handleChange = (event) => {
    SetPageSize(event.target.value);
    setRerander(!Rerander);
  };

  const Dosearch = (SearchValue) => {
    setFilterText(SearchValue);
    setSelectedAccOwner(SearchValue.value);
    setRerander(!Rerander);
  };

  const handleClear = () => {
    //if (filterText) {
    setFilterText(null);
    setSelectedAccOwner("");
    setSelectedInvoicePeriod("");
    setSingleValue(mvalue);
    SetPageSize(10);
    setRerander(!Rerander);
    // }
  };

  function getAllOwnersBillingHistory() {
    setShowLoader(true);
    let data = {
      pageSize: PageSize,
      page: PageNumber,
      accOwnerFilter: selectedAccOwner,
      invoicePeriodFilter: selectedInvoicePeriod,
    };
    getAllOwnersBillingHistoryAction(data)
      .then((res) => {
        // console.log("here getBillingHistoryAction", res);
        // console.log("here no of pgs", res.data.data.total);
        setShowLoader(false);
        setBillingHistory(res.data.data);
        setnumberOfPages(res.data.total);
      })
      .catch((err) => {
        setShowLoader(false);
        setBillingHistory([]);
        // console.log(err);
      });

    return billingHistory;
  }

  function getInvoiceDetails(userId, invoicePeriod) {
    let data = {
      userId: userId,
      invoicePeriod: invoicePeriod,
    };
    getInvoiceByPeriodAction(data)
      .then((res) => {
        let invoiceData = { ...invoiceDetails };
        invoiceData = res.data;
        setInvoiceDetails(invoiceData);
        //setRerander(!Rerander);
      })
      .catch((err) => {
        // console.log(err);
      });

    return invoiceDetails;
  }

  function getAllAccOwners() {
    getAllAccOwnersAction()
      .then((res) => {
        // console.log("getAllAccOwners", res);
        let accOwnersData = { ...accOwnersList };
        accOwnersData = res.data;
        setAccOwners(accOwnersData);
        setShowLoader(false);
      })
      .catch((err) => {
        // console.log(err);
        setShowLoader(false);
      });

    return accOwnersList;
  }

  function openInvoicePrompt(userId, invoicePeriod, iscurrentflag, id) {
    // getInvoiceDetails(userId, invoicePeriod);
    setUserId(userId);
    setInvoicePeriod(invoicePeriod);
    setInvoicePrompt(true);
    setIsCurrentInvoice(iscurrentflag);
    setInvoiceId(id);
  }

  function closeInvoicePrompt() {
    setInvoicePrompt(false);
  }

  function RecepitModal() {
    setInvoiceReceipt(false);
  }

  function confirmPaymentCapture(userId, invoiceperiod, invoiceidd) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="">
            <div className="react-confirm-alert-body">
              <h2>Confirmation</h2>
              <p>
                Payment will be processed after you click the 'Yes' button. Do
                you want to go on?
              </p>
              <div className="react-confirm-alert-button-group">
                <button
                  onClick={() => {
                    billingPaymentCapture(userId, invoiceperiod, invoiceidd);
                    onClose();
                  }}
                >
                  {" "}
                  Yes{" "}
                </button>
                <button onClick={onClose}>No</button>
              </div>
            </div>
          </div>
        );
      },
    });
  }

  function getPaymentReceiptfunctions(invoice) {
    let data = {
      invoiceID: invoice._id,
      invoicePeriod: invoice.invoicePeriod,
    };
    setShowLoader(true);
    getPaymentRecipt(data)
      .then((res) => {
        // console.log("186res", res);
        if (res && res.status === 200) {
          setReceipthtml(res.data);
          setShowLoader(false);
          setInvoiceReceipt(true);
          // console.log("===res===4545", res);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  }

  function billingPaymentCapture(userId, invoiceperiod, invoiceidd) {
    setShowLoader(true);
    let data = {
      userid: userId,
      invoicePeriod: invoiceperiod,
      invoiceid: invoiceidd,
    };
    billingPaymentCaptureAction(data)
      .then((res) => {
        // console.log("billingPaymentCaptureAction", res);
        setShowLoader(false);
        if (res.status === code.OK) {
          toastMessage(code.SUCCESS, res.data.data);
          setRerander(!Rerander);
        } else {
          toastMessage(code.ERROR, res.data.data);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        // console.log(err);
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
      });
  }

  let rows = [];

  let newDate = new Date();
  let currentMonth = newDate.getMonth() + 1;
  let currentYear = newDate.getFullYear();

  let invoicePeriodFrontend = currentYear + ("0" + currentMonth).slice(-2);

  // console.log("===invoicePeriodFrontend===", invoicePeriodFrontend);

  for (var i = 0, len = billingHistory && billingHistory.length; i < len; i++) {
    let invoice = billingHistory[i];
    let data = {
      accOwnerName: invoice.fullname ? invoice.fullname : "",
      // monthYear: moment(invoice.invoiceDate).format("MMM YYYY"),
      monthYear: moment(String(invoice.invoicePeriod)).format("MMM YYYY"),
      amount: currencyFormat(invoice.finalAmount),
      PaymentStatus: invoice.invoiceStatus,
      status:
        invoice.invoicePaid && invoice.invoiceStatus === "SUCCESS" ? (
          <Tooltip title="PAID">
            <CheckCircle className="check" style={{ color: "green" }} />
          </Tooltip>
        ) : invoice.invoiceStatus === "FAILURE" ? (
          <Tooltip title="FAILURE">
            <CheckCircle className="check" style={{ color: "red" }} />
          </Tooltip>
        ) : invoice.invoiceStatus === "UNPAID" ? (
          <Tooltip title="UNPAID">
            <CheckCircleOutline className="check-out" />
          </Tooltip>
        ) : (
          <Tooltip title="PROCESS">
            <CheckCircle className="check" style={{ color: "orange" }} />
          </Tooltip>
        ),
      created: invoice.invoicePaid
        ? moment(invoice.paymentDate).format("MM-DD-YYYY")
        : "-",
      action: (
        <div className="action-btns">
          <Button
            variant="transparent"
            onClick={() => {
              openInvoicePrompt(
                invoice.userId,
                invoice.invoicePeriod,
                invoice.isCurrentInvoice,
                invoice._id
              );
            }}
          >
            <Tooltip title="View">
              <Visibility />
            </Tooltip>
          </Button>
          {invoice.invoicePaid && (
            <>
              <Button
                variant="transparent"
                // onClick={() =>
                //   (window.location.href = invoice.payment[0].invoicepdf)
                // }
                onClick={() => getPaymentReceiptfunctions(invoice)}
              >
                <Tooltip title="Download">
                  <SaveAlt />
                </Tooltip>
              </Button>
            </>
          )}
          {/* {!invoice.invoicePaid && (
            <Button
              variant="transparent"
              onClick={() => {
                console.log("payment capture");
                confirmPaymentCapture(invoice.userId, invoice.invoicePeriod);
              }}
            >
              <Tooltip title="Payment Capture">
                <Payment />
              </Tooltip>
            </Button>
          )} */}

          {!invoice.invoicePaid &&
          (invoice.invoiceStatus == "FAILURE" ||
            invoice.invoiceStatus == "UNPAID") &&
          invoicePeriodFrontend != invoice.invoicePeriod ? (
            <Button
              variant="transparent"
              onClick={() => {
                // console.log("payment capture");
                confirmPaymentCapture(
                  invoice.userId,
                  invoice.invoicePeriod,
                  invoice._id
                );
              }}
            >
              <Tooltip title="Pay Now">
                <Payment />
              </Tooltip>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    };

    rows.push(data);
  }

  let options = [];
  for (var i = 0, len = accOwnersList.length; i < len; i++) {
    let accOwner = accOwnersList[i];
    let accOwnerData = {
      label: accOwner.name,
      value: accOwner.value,
    };
    options.push(accOwnerData);
  }

  return (
    <div>
      <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
        <Col xs="4">
          <h4 className="title-med mt-0 pt-1">Billing History</h4>
        </Col>
      </Row>

      {showLoader ? (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : rows.length === 0 ? (
        <>
          <div
            className="d-flex justify-content-end"
            style={{ columnGap: "10px" }}
          >
            <CalendarMonthIcon style={{ marginTop: "7px" }} />

            <Picker
              ref={pickAMonth}
              years={getYearsArray()}
              value={singleValue}
              lang={pickerLang.months}
              onChange={handleAMonthChange}
              onDismiss={handleAMonthDissmis}
            >
              <MonthBox
                value={makeText(singleValue)}
                onClick={handleClickMonthBox}
              />
            </Picker>
            <Search style={{ marginTop: "10px" }} />
            {/* <DebounceInput
              id="search"
              minLength={0}
              debounceTimeout={1500}
              onChange={(e) => Dosearch(e.target.value)}
              placeholder="Search"
              value={filterText}
              autoComplete="off"
            /> */}
            <Col xs="4" className="pl-0">
              <ReactSelect
                isClearable={false}
                closeMenuOnSelect={true}
                placeholder="Select Studio Owner"
                options={options}
                className="react-select-wrapper react-select-multi react-select-buyer-multi"
                onChange={(e) => Dosearch(e)}
                value={filterText}
              />
            </Col>
            <Button
              type="button"
              onClick={handleClear}
              variant="primary"
              className="btn-blue btn-head"
              style={{ marginRight: "19px" }}
            >
              Clear
            </Button>
          </div>
          <div className="no-transaction no-record no-datatable">
            <div className="no-transaction-inner">
              <img src={noRecord} alt="no record" />
              <p>No record found</p>
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className="d-flex justify-content-end"
            style={{ columnGap: "10px" }}
          >
            <CalendarMonthIcon style={{ marginTop: "7px" }} />

            <Picker
              ref={pickAMonth}
              years={getYearsArray()}
              value={singleValue}
              lang={pickerLang.months}
              onChange={handleAMonthChange}
              onDismiss={handleAMonthDissmis}
            >
              <MonthBox
                value={makeText(singleValue)}
                onClick={handleClickMonthBox}
              />
            </Picker>
            <FormControl sx={{ m: 0, minWidth: 120 }} size="small">
              <InputLabel id="demo-select-small">Limit</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={PageSize}
                label="Page"
                onChange={handleChange}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
            <Search style={{ marginTop: "10px" }} />
            {/* <DebounceInput
              id="search"
              minLength={0}
              debounceTimeout={1500}
              onChange={(e) => Dosearch(e.target.value)}
              placeholder="Search"
              value={filterText}
              autoComplete="off"
            /> */}
            <Col xs="4" className="pl-0">
              <ReactSelect
                isClearable={false}
                closeMenuOnSelect={true}
                placeholder="Select Studio Owner"
                options={options}
                className="react-select-wrapper react-select-multi react-select-buyer-multi"
                onChange={(e) => Dosearch(e)}
                value={filterText}
              />
            </Col>
            <Button
              type="button"
              onClick={handleClear}
              variant="primary"
              className="btn-blue btn-head"
              style={{ marginRight: "19px" }}
            >
              Clear
            </Button>
          </div>
          <DataTable
            title="Contacts"
            columns={columns}
            data={rows}
            persistTableHead
            style={{ marginTop: "10px" }}
          />
        </>
      )}

      {rows.length > 0 && (
        <div style={{ marginTop: 10 }}>
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            pageCount={numberOfPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination justify-content-center"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      )}

      {/* Invoice Details Modal */}
      {invoicePrompt && (
        <Modal
          show={invoicePrompt}
          onHide={() => closeInvoicePrompt()}
          aria-labelledby="example-custom-modal-styling-title"
          backdrop={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Invoice Details
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <InvoiceDetailsTable
              userId={userId}
              invoicePeriod={invoicePeriod}
              isCurrentInvoice={isCurrentInvoice}
              invoiceId={invoiceId}
            />
          </Modal.Body>
        </Modal>
      )}

      {/* receipt modal */}
      <Modal
        show={invoiceReceipt}
        onHide={() => RecepitModal()}
        aria-labelledby="example-custom-modal-styling-title"
        backdrop={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            DOTWORK
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="pb-0">
          <BillingReceipt receipthtml={receipthtml} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getAllOwnersBillingHistoryAction,
    getInvoiceByPeriodAction,
    getAllAccOwnersAction,
    billingPaymentCaptureAction,
    getPaymentRecipt,
  }
)(BillingHistory);
